import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "@/styles/product_list.module.scss";

const ProductCardSkeleton = () => {
  return (
    <div className={styles.product}>
      <div className={styles.pad_10}>
        <Skeleton style={{ width: 100 }} />
        <Skeleton style={{ width: 200 }} />
        <Skeleton style={{ marginTop: 30, height: 230 }} />
        <Skeleton style={{ marginTop: 20, width: 150 }} />
      </div>
      <div className={styles.product_details}>
        <div className={styles.pad_10}>
          <Skeleton style={{ width: 150 }} />
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
